let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("8059b")).then(() => parcelRequire('41GKb'));